import React, { Component } from 'react';
import {Row, Col, Button, ButtonGroup} from 'react-bootstrap';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Blocks from './components/Blocks';
import Form from './components/Form';
import API from '../../services/API';
import Icon from "../../components/Icon";
import SelectWrap from "../../components/SelectWrap";
import { handleFieldChange } from "../../Utils";
import SyncMessage from "../../components/SyncMessage";

class BidderSourcesBlock extends Component {
    constructor() {
        super();

        this.state = {
            isLoading: false,
            isShowForm: false,
            source: null,
            affids: [],
            availableSources: [],
            syncData: null
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleAddBtnClick = this.handleAddBtnClick.bind(this);
        this.handleSync = this.handleSync.bind(this);
        this.handleRemoveAll= this.handleRemoveAll.bind(this);
        this.handleRemoveBtnClick = this.handleRemoveBtnClick.bind(this);
        this.handleFormHide = this.handleFormHide.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    componentDidMount() {
        API.BidderSources.getAvailableSources().then(sources => {
            this.setState({ availableSources: sources });
        });
    }

    componentWillUpdate(nextProps, nextState) {
        const { source } = nextState;

        if(this.state.source !== source) this.loadAffids(source);
    }

    loadAffids(source) {
        this.setState({ isLoading: true });

        API.BidderSourcesBlock.get(source).then(affids => this.setState({ affids, isLoading: false }));
    }

    handleAddBtnClick() {
        this.setState({ isShowForm: true });
    }

    handleFormHide() {
        this.setState({ isShowForm: false, payoutToUpdate: null });
    }

    handleFormSubmit(feed, affids) {
        this.setState({
            isShowForm: false,
            isLoading: true
        });
        const { source } = this.state;

        API.BidderSourcesBlock.save(source, feed, affids.split(',')).then(() => this.loadAffids(source));
    }

    handleRemoveBtnClick(id) {
        this.setState({ isLoading: true });

        API.BidderSourcesBlock.remove(id).then(() => this.loadAffids(this.state.source));
    }

    handleSync() {
        this.setState({ isLoading: true });

        API.Sync(['bidder', 'bidder-adk'], 'sources/block', 8081)
            .then((res) => {
                this.setState({ isLoading: false, syncData: { res } });
            })
            .catch(err => {
                this.setState({ isLoading: false, syncData: { reqErr: err } });
            });
    }

    handleRemoveAll() {
        this.setState({ isLoading: true });

        API.BidderSourcesBlock.removeAll(this.state.source).then(() => this.loadAffids(this.state.source));
    }

    getForm() {
        if(this.state.isShowForm) {
            return <Form
                availableSources={this.state.availableSources}
                onSubmit={this.handleFormSubmit}
                onFormHide={this.handleFormHide}
            />;
        }
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Bidder Sources Block"/>
                <Row>
                    <Col lg={3}>
                        <SelectWrap
                            value={this.state.source}
                            name="source"
                            label="Source:"
                            values={this.state.availableSources}
                            onChange={this.handleFieldChange}
                        />
                    </Col>
                    <Col lg={9}>
                        <ButtonGroup className="pull-right m-b-15">
                            <Button bsStyle="success" onClick={this.handleAddBtnClick}><Icon name="plus"/> Add</Button>
                            <Button bsStyle="info" onClick={this.handleSync}> Sync</Button>
                            <Button bsStyle="danger" onClick={this.handleRemoveAll}>Remove</Button>
                        </ButtonGroup>
                    </Col>
                </Row>
                <SyncMessage {...this.state.syncData} />
                {this.getForm()}
                <Blocks blocks={this.state.affids} onRemove={this.handleRemoveBtnClick} />
            </Container>
        );
    }
}

export default BidderSourcesBlock;


// WEBPACK FOOTER //
// ./src/scenes/BidderSourcesBlock/index.js